export default "__VITE_ASSET__Yf7KBTcS__"